function showContent(container) {
  const panel = $jq3(container).find('.jplist-dd-amount-panel');
  const content = $jq3(container).find('.jplist-dd-amount-content');

  $jq3(container).data('is-open', true);
  $jq3(container).addClass('jplist-dd-opened');
  panel.addClass('jplist-dd-opened');
  content.addClass('jplist-dd-opened');

  document.addEventListener('click', function() {
    hideContent($jq3(container));
  });
}

function hideContent(container) {
  const panel = $jq3(container).find('.jplist-dd-amount-panel');
  const content = $jq3(container).find('.jplist-dd-amount-content');

  $jq3(container).data('is-open', false);
  $jq3(container).removeClass('jplist-dd-opened');

  panel.removeClass('jplist-dd-opened');
  content.removeClass('jplist-dd-opened');

  document.removeEventListener('click', function() {
    hideContent($jq3(container));
  });
}

export function lists() {
  $jq3('.jplist-dd-amount').on('click', function(e) {
    e.stopPropagation();

    if ($jq3(this).data('is-open') === undefined || $jq3(this).data('is-open') === false) {
      showContent($jq3(this));
    } else {
      hideContent($jq3(this));
    }
  });
}
